// The "Charge card" button, for every role.
//
// It never charges by itself. With the `card_charging` feature off (the default:
// Atlas switches it on once the practice's merchant account is connected) a click
// shows one sentence saying so and makes NO request. With it on, a patient with no
// card on file gets a disabled button, and one with a card hands the row to
// `onCharge`, whose owner runs the existing confirm-and-charge flow
// (POST …/ar/bill-patients). The confirm, and the money, live there — not here.

import React, { useState } from "react";
import "./ChargeCardAction.css";

export const CARD_CHARGING_OFF_MESSAGE =
  "Card charging is switched on by Atlas once your merchant account is connected";

// The client view. The backend keeps write_access_required on /ar/bill-patients,
// so a client-role user can never charge; say so instead of letting them reach a
// confirm that can only 403.
export const CARD_CHARGING_READ_ONLY_MESSAGE =
  "Charging a card from the client view is done by your Atlas biller";

export default function ChargeCardAction({
  practiceId,
  patient,
  cardChargingOn,
  readOnly = false,
  onCharge,
}) {
  // null | "off" | "read_only"
  const [notice, setNotice] = useState(null);

  const hasCard = !!(patient && patient.has_card_on_file);
  const disabled = !readOnly && !!cardChargingOn && !hasCard;

  const handleClick = () => {
    if (readOnly) {
      setNotice("read_only");
      return;
    }
    if (!cardChargingOn) {
      setNotice("off");
      return;
    }
    if (!hasCard) return;
    if (onCharge) onCharge(patient);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-secondary charge-card-btn"
        onClick={handleClick}
        disabled={disabled}
        title={disabled ? "No card on file" : undefined}
        data-practice-id={practiceId}
      >
        Charge card
      </button>
      {notice && (
        <div className="modal-overlay" onClick={() => setNotice(null)}>
          <div
            className="modal-content charge-card-off-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-label="Card charging"
          >
            <div className="charge-card-off-message">
              <span>
                {notice === "read_only"
                  ? CARD_CHARGING_READ_ONLY_MESSAGE
                  : CARD_CHARGING_OFF_MESSAGE}
              </span>
              <button
                className="charge-card-off-close"
                onClick={() => setNotice(null)}
                aria-label="Dismiss"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
